module.exports = flarum.core.compat['components/Dropdown'];